import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

const genericFormat = ({street, houseNumber, zip, city, inline=true}) => ({
  __html: `${street}${houseNumber ? ' ' + houseNumber : ''}${inline ? ', ' : '<br />'} ${zip} ${city}`
});

const ukFormat = ({street, zip, city, inline=true}) => ({
  // there is no houseNumber in the result for uk addressses
  __html: `${street} ${inline ? ', ' : '<br />'} GB-${zip} ${city}`
});

const genericCountry = countryCode => ({street, zip, city, inline=true}) => ({
  // there is no houseNumber in the result for uk addressses
  __html: `${street} ${inline ? ', ' : '<br />'} ${countryCode}-${zip} ${city}`
});

const formats = {
  de: genericFormat,
  gb: ukFormat,
  fr: genericCountry('FR'),
  es: genericCountry('ES'),
  be: genericCountry('BE'),
  lu: genericCountry('LU'),
  at: genericCountry('AT'),
  dk: genericCountry('DK'),
  se: genericCountry('SE'),
  fi: genericCountry('FI'),
  nl: genericCountry('NL')
};

const format =  country => (
  formats[country] ? formats[country] : genericFormat
);

const Address = (props) => (
  <address
    className={['address', props.className].join(' ')}
    dangerouslySetInnerHTML={format(props.country)(props)}>
  </address>
);

const mapStateToProps = ({config}) => ({
  country: config.country
});

const AddressContainer = connect(mapStateToProps)(Address);

Address.propTypes = {
  street: PropTypes.string.isRequired,
  houseNumber: PropTypes.string,
  zip: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired
};

export default AddressContainer;
